import React from "react";
import "./PaytmWaitScreen.css";

const COPY = {
  opening: {
    title: "Please wait…",
    message: "We're taking you to the secure Paytm payment page.",
  },
  checking: {
    title: "Verifying your payment",
    message: "This usually takes a few seconds.",
  },
};

const PaytmWaitScreen = ({ mode = "opening" }) => {
  const copy = COPY[mode] || COPY.opening;

  return (
    <div className="paytm-wait" role="status" aria-live="polite">
      <div className="paytm-wait__card">
        <div className="paytm-wait__spinner" aria-hidden="true">
          <span className="paytm-wait__ring" />
          <span className="paytm-wait__lock">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <rect x="5" y="10" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="2" />
              <path d="M8 10V7a4 4 0 0 1 8 0v3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </span>
        </div>

        <h1 className="paytm-wait__title">{copy.title}</h1>
        <p className="paytm-wait__message">{copy.message}</p>

        <div className="paytm-wait__dots" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>

        <p className="paytm-wait__warning">Please do not refresh the page or press back.</p>

        <div className="paytm-wait__secure">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M12 3l7 3v5c0 4.5-3 8.3-7 10-4-1.7-7-5.5-7-10V6l7-3z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinejoin="round"
            />
            <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <span>100% secure payments powered by Paytm</span>
        </div>
      </div>
    </div>
  );
};

export default PaytmWaitScreen;
